export enum AlertPhase {
  C1 = 'c1',
  C2 = 'c2',
  C3 = 'c3',
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  TEMP = 'temp',
  RH = 'rh',
  RSSI = 'rssi',
  TEMPERATURE_AVG = 't_avg',
  PRESSURE_AVG = 'p_avg',
  HUMIDITY_AVG = 'h_avg',
  BATTERY = 'batt',
  SET_TEMPERATURE = 'setTemperature',
  IN_TEMPERATURE = 'inTemperature',
  IN_HUMIDITY = 'inHumidity',
  IN_PRESSURE = 'inPressure',
  IN_DEW_POINT = 'inDewPoint',
  OUT_TEMPERATURE = 'outTemperature',
  OUT_HUMIDITY = 'outHumidity',
  OUT_PRESSURE = 'outPressure',
  OUT_DEW_POINT = 'outDewPoint',
  SET_POINT = 'setPoint',
  BATTERY_VALVE = 'battery',
  UNKNOWN = 'unknown'
}
